import React, { useEffect, useState } from "react"
import logo from "../assets/icons/logo.png"
import subscribe from "../assets/icons/subscribe.png"
import './Subscribe.scss'
import config from "../config"
import { useHistory } from "react-router-dom";
import Modal from 'react-modal';
import { reactLocalStorage } from 'reactjs-localstorage';


const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '80%'
    },
};

Modal.setAppElement('#root');


function OTP({ setshowSideMenu }) {
    const [pin, setPin] = useState('')
    const [message, setMessage] = useState('')
    const [modalIsOpen, setIsOpen] = useState(false);
    const [status, setStatus] = useState('')
    let history = useHistory();

    console.log('inside OTP container')

    useEffect(() => {
        setshowSideMenu()
    }, [])

    

    function submitFrom(e) {
        e.preventDefault()
        console.log("form is submitted")
        const url = `${config.get('base')}${config.get('activate')}`
        fetch(url, {
            method: 'POST',
            body: JSON.stringify({ 'msisdn': reactLocalStorage.get("msisdn"), token: pin }),
            headers: config.get('headers')
        })
            .then(res => {
                if (!res.ok) { throw res }
                return res.json()
            })
            .then((result) => {
                console.log('result message::', result)
                if (result.status === 'success') {
                    if (reactLocalStorage.get("previousPage") === 'subscripttion') {
                        const url = `${config.get('base')}${config.get('subscribe')}`
                        fetch(url, {
                            method: 'POST',
                            body: JSON.stringify({ 'msisdn': reactLocalStorage.get("msisdn") }),
                            headers: config.get('headers')
                        })
                            .then(res => {
                                if (!res.ok) { throw res }
                                return res.json()
                            })
                            .then((result) => {
                                console.log('result message::', result)
                                setMessage(result.message)
                                setStatus(result.status)
                                setIsOpen(true)
                                openModal()
                            },
                                (error) => {
                                    console.log('error:::', error)
                                })
                    } else {
                        checksub()
                    }
                } else {
                    setStatus('failed')
                    setMessage(result.message)
                    openModal()
                }
            },
                (error) => {
                    console.log('error:::', error)
                    setStatus('failed')
                    setMessage(error)
                    openModal()
                })
    }

    const checksub = () => {
        const msisdn =reactLocalStorage.get("msisdn")
        const uid =  reactLocalStorage.get("uid");
        const url = `${config.get('base')}${config.get('checkSub')}`
        fetch(url, {
            method: 'POST',
            body: JSON.stringify({ 'msisdn': msisdn, 'uid' : uid }),
            headers: config.get('headers')
        })
            .then(res => {
                if (!res.ok) { throw res }
                return res.json()
            })
            .then((result) => {
                console.log('result message::', result)
                reactLocalStorage.set("subStatus", result.subStatus)
                // reactLocalStorage.set("subStatus",'active');
                history.push('/home')
            },
                (error) => {
                    console.log('error:::', error)
                })
    }

    function handleChange(e) {
        setPin(e.target.value)
    }

    function openModal() {
        setIsOpen(true);
    }

    function closeModal() {
        setIsOpen(false);
    }

    function handleBtnClick() {
        // if (status === 'failed' && reactLocalStorage.get("previousPage") !== 'subscripttion') {
        //     closeModal()
        // }else if(status === 'failed'){
        //     history.push('/home')
        // }else {
        //     window.open(reactLocalStorage.get("gameUrl"), "_self")
        // }
       
        if (status === 'failed') {
            closeModal()
            setPin('')
        }else {
            window.open(reactLocalStorage.get("gameUrl"), "_self")
        }
    }

    return (
        <div className="container m-w">
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <div>{message}</div>
                <button
                    onClick={handleBtnClick}
                    style={{
                        width: '30%',
                        backgroundColor: 'rgb(23 54 206)',
                        color: 'white',
                        padding: '4% 1%',
                        margin: '8px 0',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontWeight: 'bold'
                    }}
                >{status === 'failed' ? 'Okay' : 'Proceed'}</button>
            </Modal>
            <div className="columns is-mobile">
                <div className="column is-full">
                    <div className="card">
                        <div className="card-content">
                            <figure className="image z-s m-1">
                                {/* <img src={zain} alt="zain logo" /> */}
                            </figure>
                            <figure className="image l-s m-2">
                                <img src={logo} alt="xgame logo" />
                            </figure>
                            <figure className="image s-s m-5 pb-5">
                                <img src={subscribe} alt="subcribe icon" />
                            </figure>
                            <form onSubmit={submitFrom}>
                                <div className="columns is-mobile is-multiline">
                                    <div className="column is-full">
                                        <div className="field">
                                            <label className="label">Enter the OTP</label>
                                            <div className="control">
                                                <input
                                                    className="input"
                                                    type="number"
                                                    value={pin}
                                                    onChange={handleChange}
                                                    placeholder="" />
                                            </div>
                                            <p className="help">Please enter the OTP send to your mobile</p>
                                        </div>
                                        <div className="control">
                                            <button className="button btn-main">Confirm OTP</button>
                                           {reactLocalStorage.get("previousPage") === 'subscripttion' && 
                                            <button className="button btn-main" onClick={()=>history.push('/')}>Cancel</button>}
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OTP